import axios, { type AxiosError } from 'axios';
import { apiUrl } from '@/shared/config/env';
import { useAuthentication } from '@/shared/composables/useAuthentication';

export const http = axios.create({ baseURL: apiUrl });

const { token, refreshAccessToken } = useAuthentication();

http.interceptors.request.use((config) => {
  if (token.value) {
    config.headers.Authorization = `Bearer ${token.value}`;
  }
  return config;
});

http.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const config = error.config as (typeof error.config & { _retried?: boolean }) | undefined;

    // A single retry, and only after a real refresh: without the flag a token
    // Keycloak refuses to renew would loop the request forever.
    if (error.response?.status === 401 && config && !config._retried) {
      config._retried = true;
      const refreshed = await refreshAccessToken(-1).catch(() => false);
      if (refreshed) return http.request(config);
    }

    return Promise.reject(error);
  }
);
